import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as CashFlowService from './../services/cashFlowService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseRatingListRequestParams } from '../utils/commonUtils';
import history from './../helpers/history';
import moment from 'moment';
import { omit } from 'lodash';
import { setAccounts, setTransactions, setTransactionsImbalance } from '../actions/cashFlowAction';

function* createReceiptsPayslip() {
    yield takeLatest(Types.RECEIPTS_PAYSLIP_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(CashFlowService.createReceiptsPayslip, action.receiptPayslip);
        successHandleCashFlow(action, action.receiptPayslip.totalAmount);
        history.push(PATHS.REPORT.CASH_FLOW_REPORT.path);
        history.go();
    }, errorHandleCashFlow(Types.RECEIPTS_PAYSLIP_FAIL)))
}

function* getTransactionsCashFlow() {
    yield takeLatest(Types.CASH_FLOW_GET_TRANSACTION_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseRatingListRequestParams(action.filters)
        const transactions = yield call(CashFlowService.getTransactionsCashFlow, params);
        yield put(setTransactions(transactions))
        yield call(getAllData, transactions, params, CashFlowService.getTransactionsCashFlow, setTransactions)
    }, errorHandleCashFlow(Types.RECEIPTS_PAYSLIP_FAIL)))
}

function* getAccountsCashFlow() {
    yield takeLatest(Types.CASH_FLOW_GET_ACCOUNT_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseRatingListRequestParams(action.filters)
        yield delay(SAGA_DELAY_TIMEOUT);
        const accounts = yield call(CashFlowService.getAccountsCashFlow, params);
        yield put(setAccounts(accounts));
        yield call(getAllData, accounts, params, CashFlowService.getAccountsCashFlow, setAccounts)
    }, errorHandleCashFlow(Types.RECEIPTS_PAYSLIP_FAIL)))
}

function* getTransactionImbalanceCashFlow() {
    yield takeLatest(Types.CASH_FLOW_GET_TRANSACTION_IMBALANCE_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseRatingListRequestParams(action.filters)
        yield delay(SAGA_DELAY_TIMEOUT);
        const transactionImbalances = yield call(CashFlowService.getTransactionImbalanceCashFlow, params);
        yield put(setTransactionsImbalance(transactionImbalances));
        yield call(getAllData, transactionImbalances, params, CashFlowService.getTransactionImbalanceCashFlow, setTransactionsImbalance)
    }, errorHandleCashFlow(Types.RECEIPTS_PAYSLIP_FAIL)))
}

function* getAllData(data = [], params = {}, funcService, funcSetDataCallback) {
    const totalPage = Math.ceil(parseInt(data.totalCount) / parseInt(data.pageSize))
    if(data.result.length > 0 && totalPage > 1) {
        for(let page = 2; page <= totalPage; page++) {
            if(!!funcService && !!funcSetDataCallback && !!params) {
                const nextData = yield call(funcService, { ...params, pageIndex: page });
                yield put(funcSetDataCallback(nextData));
            }
        }
    }
}

function successHandleCashFlow(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.cashFlow.title')} ${Func.formatMoney(value)}`
    })
}

function errorHandleCashFlow(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'cashFlow');
}

export function* cashFlowSaga() {
    yield all([
        fork(createReceiptsPayslip),
        fork(getTransactionsCashFlow),
        fork(getAccountsCashFlow),
        fork(getTransactionImbalanceCashFlow)
    ])
}
